module.exports = __webpack_public_path__ + "img/backtobrown_hair.5b44a1f3.jpg";